import { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import { message } from "antd";

const GradeDetailsForm = (props) => {
  const [cropVarietyData, setCropVarietyData] = useState([]);
  const [croptypeId, setCroptypeId] = useState(0);
  const [cropTypeList, setCropTypeList] = useState([]);
  const [cropList, setCropList] = useState([]);
  const [cropFilterList, setCropFilterList] = useState([]);
  const [varietyFilterList, setVarietyFilterList] = useState([]);
  const [varietyId, setVarietyId] = useState(0);
  const [cropId, setCropId] = useState(0);
  const [gradeType, setGradeType] = useState("");
  const [gradeName, setGradeName] = useState("");

  const { sendRequest: getcropType } = useHttp();
  const fillCropType = () => {
    getcropType(
      {
        url: "/api/croptypes/",
      },
      (res) => {
        if (res) {
          setCropTypeList(res);
        }
      }
    );
  };

  useEffect(() => {
    fillCropType();
  }, [getcropType]);

  const { sendRequest: getcrop } = useHttp();
  const fillCrop = () => {
    getcrop(
      {
        url: "/api/crops/",
      },
      (res) => {
        if (res) {
          setCropList(res);

          const cropFilterList = res.filter(
            (item) => parseInt(item.croptypeId) === parseInt(croptypeId)
          );

          setCropFilterList(cropFilterList);
        }
      }
    );
  };

  useEffect(() => {
    fillCrop();
  }, [getcrop, croptypeId]);

  const { sendRequest: getcropVariety } = useHttp();

  const getCropVarietyDetail = () => {
    getcropVariety(
      {
        url: "/api/varieties/",
      },
      (res) => {
        if (res) {
          setCropVarietyData(res);
        }
      }
    );
  };

  useEffect(() => {
    getCropVarietyDetail();
  }, [getcropVariety, props.update]);

  const { sendRequest: postGrade } = useHttp();

  const submitHandler = async (e) => {
    e.preventDefault();

    const data = {
      gradeName: gradeName,
      varietyId: varietyId,
      gradeType: gradeType,
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId: props.sId,
    };
    if (props.update) {
      data["gradeId"] = props.update.gradeId;
    }
    // console.log(data);

    try {
      await postGrade(
        {
          url: "/api/gradeMaster/",

          method: props.update ? "PUT" : "POST",
          body: data,
        },
        (data) => {
          toast.success(`Grade Details ${props.update ? "Updated" : "Added"}`);

          console.log(data);

          props.addForm(false);
        },
        (error) => {
          toast.error(error);
        }
      );
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const cropTypeOnchangedHandler = (event) => {
    var croptype = event.target.value;
    setCroptypeId(event.target.value);

    const cropFilterList = cropList.filter(
      (item) => parseInt(item.croptypeId) === parseInt(croptype)
    );

    setCropFilterList(cropFilterList);
  };

  const cropChangedHandler = (e) => {
    setCropId(e.target.value);
  };

  useEffect(() => {
    if (cropId && cropVarietyData.length > 0) {
      const varietiesFilterList = cropVarietyData.filter(
        (item) => parseInt(item.cropId) === parseInt(cropId)
      );
      setVarietyFilterList(varietiesFilterList);
    }
  }, [cropId, cropVarietyData, props.update]);

  useEffect(() => {
    console.log(props.update);
    if (props.update) {
      setGradeName(props.update.gradeName);
      setGradeType(props.update.gradeType);
      setCroptypeId(props.update.croptypeId);
      setCropId(props.update.cropId);
      setVarietyId(props.update.varietyId);
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Grade Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <div>
                          {" "}
                          <label>Crop Type </label>
                        </div>
                        <select
                          id="cropTypeNameId"
                          className="form-control"
                          value={croptypeId}
                          onChange={cropTypeOnchangedHandler}
                        >
                          <option value="">Select</option>
                          {cropTypeList &&
                            cropTypeList.map((x) => (
                              <option key={x.croptypeId} value={x.croptypeId}>
                                {x.name}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Crop Name </label>

                        <select
                          id="cropNameId"
                          className="form-control"
                          value={cropId}
                          onChange={cropChangedHandler}
                        >
                          <option value="">Select</option>
                          {cropFilterList &&
                            cropFilterList.map((x) => (
                              <option key={x.cropId} value={x.cropId}>
                                {x.cropName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Crop Variety name</label>

                        <select
                          id="cropNameId"
                          className="form-control"
                          value={varietyId}
                          onChange={(e) => {
                            setVarietyId(e.target.value);
                          }}
                        >
                          <option value="">Select</option>
                          {varietyFilterList &&
                            varietyFilterList.map((x) => (
                              <option key={x.varietyId} value={x.varietyId}>
                                {x.varietyName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Grade Type</label>
                        <select
                          id="gradeType"
                          className="form-control"
                          value={gradeType}
                          onChange={(e) => {
                            setGradeType(e.target.value);
                          }}
                        >
                          <option value="">Select</option>

                          <option value="Procurment">Procurment</option>
                          <option value="Sales">Sales</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Grade Name</label>
                        <input
                          type="text"
                          id="grade Name"
                          className="form-control"
                          autoComplete="off"
                          value={gradeName}
                          onChange={(e) => {
                            setGradeName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="colmd-12">
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default GradeDetailsForm;
